module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic3.cf1c9a70.png";